<template lang="html">

    <article class="oferta-el -listado row-start">

 

        <div class="contenedor-texto">

            <div class="top row-start">
                <h3 title="Empresa" class="empresa" v-if="!!data.empresa">{{data.empresa}}</h3>
                <h3 class="categoria" v-if="!!data.esProgramaIndependiente">Programas
                    independientes</h3>
                <h3 class="categoria" v-if="!!data.esInternacional">Práctica
                    internacional</h3>
                <h3 class="categoria" v-if="!!data.esInterna">Práctica interna</h3>
                <h3 class="categoria" v-if="!!data.curricular">Práctica curricular</h3>
                <h3 title="Sector" class="categoria -sector" v-if="!!data.sectorEmpresa">{{data.sectorEmpresa}}</h3>
            </div>

            <div class="middle row-between">
                <h2 class="titulo">{{data.titulo}}</h2>
                <div class="descripcion" v-if="data.descripcion.includes('<p>')"
                    v-html="data.descripcion"></div>
                <div class="descripcion" v-else>
                    <p v-html="data.descripcion"></p>
                </div>
                <h3 class="estudios row-start" v-if="!!data.titulaciones_Requeridas">
                    <strong>Estudios: </strong>
                    <a v-if="data.titulaciones_Requeridas.length> 1"
                        class="showtitulaciones" @click="showpopup = true" >Ver
                        titulaciones</a>
                    <span v-else> {{data.titulaciones_Requeridas[0]}}</span>
                </h3>
            </div>

        </div>

        <div class="tips column-start">
            <h3 class="fecha">{{data.fecha}}</h3>
            <h3 v-if="!!data.provincia || !!data.localidad" class="localizacion">
                {{data.provincia}}
                <template v-if="!!!data.provincia & !!data.localidad">
                    {{data.localidad}}
                </template>
                <template v-if="!!data.pais">
                    , {{data.pais}}
                </template>
            </h3>
        </div>

        <router-link class="enlace-cover" v-if="!!data.esProgramaIndependiente"
            :to="$t('enlaces.programaindependiente')+'/'+data.urlAcceso"></router-link>
        <router-link class="enlace-cover" v-else
            :to="$t('enlaces.oferta')+'/'+data.urlAcceso"></router-link>

        <div class="cover-popup row-center" v-if="showpopup">
            <span class="close-cover" @click="showpopup= false"></span>
            <div class="popup -estudios">
                <a class="close" @click="showpopup= false">✕</a>
                <h2 class="title-pop">Listado de estudios</h2>
                <ul class="row-start">
                    <li v-for="(tit,key) in titulacionesOrder">
                        {{tit}}
                    </li>
                </ul>

            </div>
        </div>


    </article>


</template>

<script lang="js">
    export default {
        name: 'oferta-el',
        props: ['data'],
        data(){
            return {
                showpopup : false
            }
        },
        computed:{
            titulacionesOrder(){
                let titulaciones;
                if(this.data.titulaciones_Requeridas.length != 0){
                    titulaciones = this.data.titulaciones_Requeridas.sort(function (p1, p2) {
                        return (p1.toLowerCase() < p2.toLowerCase()) ? -1 : 1;
                    });
                }
                return titulaciones;
            }
        }

    }
</script>


// WEBPACK FOOTER //
// src/components/parts/oferta-el.vue